import { Theme } from "../../../types";
import { CSSObject } from "@emotion/react";
import { responsiveContainerPadding } from "../../../utils/breakpoints";

export const clientsAnalyticsStyles = (
  theme: Theme,
): { [key: string]: Record<string, CSSObject | string | number> } => ({
  container: {
    width: "100%",
    padding: "24px",
    background: "#fff",
    borderRadius: 8,
    boxSizing: "border-box",
    overflow: "hidden",
    ...responsiveContainerPadding(24),
  },
  loadingWrap: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
  },
  loadingIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    border: "4px solid #E7E6E6",
    borderTopColor: theme.colorSchema.buttons.primary.background[0],
    animation: "clientsAnalyticsLoadingSpin 0.8s linear infinite",
    "@keyframes clientsAnalyticsLoadingSpin": {
      from: { transform: "rotate(0deg)" },
      to: { transform: "rotate(360deg)" },
    },
  },
  summaryText: {
    color: theme.colorSchema.colors.mainText,
    marginBottom: "16px",
    fontFamily: "Gilroy-Regular",
  },
  emptyText: {
    color: theme.colorSchema.colors.mainText,
    fontFamily: "Gilroy-Regular",
    padding: "20px 0",
  },
  groupsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  groupHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    background: "#F6F6F6",
    borderRadius: 8,
    height: 50,
    padding: "0 20px",
    border: "none",
    cursor: "pointer",
  },
  groupHeaderLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
  },
  groupLabel: {
    fontFamily: "Gilroy-SemiBold",
    color: theme.colorSchema.colors.mainText,
    fontSize: 15,
  },
  groupCount: {
    fontFamily: "Gilroy-Regular",
    color: theme.colorSchema.colors.mainText,
    fontSize: 13,
    opacity: 0.7,
  },
  icon: {
    width: 12,
    height: 12,
  },
  groupBody: {
    background: theme.colorSchema.colors.mainBackground,
    borderRadius: 8,
    overflowX: "auto",
    overflowY: "hidden",
    maxWidth: "100%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  },
  tr: {
    cursor: "pointer",
  },
  th: {
    background: "#E7E6E6",
    padding: "10px 20px",
    fontWeight: "bold",
    color: theme.colorSchema.colors.primary,
    textAlign: "left",
  },
  td: {
    padding: "10px 20px",
    textAlign: "left",
    color: theme.colorSchema.colors.mainText,
    borderBottom: `1px solid ${theme.colorSchema.colors.thirdBackground}`,
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
});
